(function () {
  'use strict';

  var promotions = { BROW25: 25, BROW30: 30 };
  var params = new URLSearchParams(window.location.search);
  var code = (params.get('promo_code') || '').trim().toUpperCase();
  var percentOff = promotions[code];
  if (!percentOff) return;

  function delimit(cents, precision, thousands, decimal) {
    var parts = (cents / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function money(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var token = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!token) return '$' + delimit(cents, 2, ',', '.');
    var value;
    switch (token[1]) {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return format.replace(token[0], value);
  }

  function show(priceInCents) {
    if (!Number.isFinite(priceInCents) || priceInCents <= 0) return;
    var promoPrice = Math.round(priceInCents * (100 - percentOff) / 100);
    document.querySelectorAll('[data-promo-product-price]').forEach(function (wrapper) {
      var original = wrapper.querySelector('[data-compare-price]');
      var price = wrapper.querySelector('[data-price]');
      if (!original || !price) return;
      wrapper.dataset.variantPrice = String(priceInCents);
      wrapper.dataset.promoCode = code;
      original.textContent = money(priceInCents);
      price.textContent = money(promoPrice);
    });
  }

  function initialize() {
    var wrapper = document.querySelector('[data-promo-product-price]');
    if (wrapper) show(Number(wrapper.dataset.variantPrice));
  }

  document.addEventListener('product:variant-change', function (event) {
    if (event.detail && event.detail.variant) show(Number(event.detail.variant.price));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
